import React from 'react';
import { LockIcon, ArrowRightIcon } from 'lucide-react';
const spaces = [{
  id: 'licencie',
  title: 'Espace licencié',
  text: 'Licence et attestation d’assurance, aéronefs déclarés, inscriptions aux stages et compétitions.',
  cta: 'Me connecter',
  primary: true
}, {
  id: 'dirigeant',
  title: 'Espace dirigeant',
  text: 'Gestion des adhésions du club, structures affiliées, listes de licenciés et comptes rendus.',
  cta: 'Accès dirigeants',
  primary: false
}];
export function MemberAccess() {
  return <section id="espaces" className="bg-ink py-16 lg:py-20" data-id="element-148" data-mp="2n468jtq13n7m">
      <div className="mx-auto grid max-w-shell gap-5 px-5 md:grid-cols-2 lg:px-8" data-id="element-149" data-mp="286nd68iuibr7">
        {spaces.map(space => <article key={space.id} className={`rounded-xl p-6 lg:p-8 ${space.primary ? 'bg-white' : 'border border-white/15 bg-white/5'}`} data-id="element-150" data-mp="2d56zwb59jrkm">
            <p className={`flex items-center gap-2 text-[12px] font-bold uppercase tracking-wider ${space.primary ? 'text-azure' : 'text-white/60'}`} data-id="element-151" data-mp="11rv2oj40e77f">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-152" data-mp="2evhg77mwh4a7" />
              Accès réservé
            </p>
            <h2 className={`ffp-display mt-3 text-2xl font-bold ${space.primary ? 'text-ink' : 'text-white'}`} data-id="element-153" data-mp="2svsbqnz5n71p">
              {space.title}
            </h2>
            <p className={`mt-2 text-[15px] leading-relaxed ${space.primary ? 'text-ink/65' : 'text-white/70'}`} data-id="element-154" data-mp="32rd8a6lgff42">
              {space.text}
            </p>
            <a href="#espaces" className={`ffp-focus mt-6 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-[14px] font-semibold transition-colors duration-150 ease-soft ${space.primary ? 'bg-flag text-white hover:bg-[#b81c22]' : 'border border-white/30 text-white hover:border-white'}`} data-id="element-155" data-mp="3bkp42mazrpha">
              {space.cta}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-156" data-mp="2e7f052xpj9ki" />
            </a>
          </article>)}
      </div>
    </section>;
}